
<div style="position: relative; ">
    <div class="v-flex">
        <c-index
            title          = "Kunden"
            :items         = "items"
            :criterion     = "customer.criterion"
            :filter-on     = "customer.filterOn"
            :filter        = "indexFilter"
            :filter-height = "filterHeight"
            :enable-search = "false"
            :miminize      = "minimize"
            :pre-index-height = "preIndexHeight"
            @selected      = "onCustomer"
            @clear-filter  = "onClearFilter"
            ref            = "index"
            class          = "w-75"
        >
            <template v-slot:filter>
                <m-customer-filter
                    @changed     = "onFilter"
                    :text-search = "enableSearch"
                    :show-misc   = "showMisc"
                    ref          = "filter"
                />

                <v-row
                    class="no-frame unknown mt-1 mb-3 mr-0"
                    v-if="showUnrefFilter"
                    :class="customer.selected && customer.selected.id === 0 ? 'unknown-selected' : ''"
                >
                    <a @click="onUnknown" class="w-100">
                        {{ unrefText }}
                    </a>
                </v-row>
            </template>

            <template v-slot:pre-index>
                <slot name="pre-index" />
            </template>

            <template v-slot:item="{ item }">
                <div class="v-flex w-100">
                    <div class="customer-name">
                        {{ item.name }}
                    </div>
                    <v-spacer />
                    <slot name="flags" v-bind:item="item" />
                    <c-tag
                        v-if      = "isType(item, 1) && showTags"
                        label     = "LM"
                        :active   = "contractStatistic(item, 1).active > 0"
                        :selected = "isSelected(customer, item)"
                        style="margin-right: 2px;"
                    />
                    <c-tag
                        v-if      = "isType(item, 2) && showTags"
                        label     = "DLS"
                        :active   = "contractStatistic(item, 2).active > 0"
                        :selected = "isSelected(customer, item)"
                    />
                </div>
            </template>
            <template v-slot:detail="{ item }">
                <slot name="detail" v-bind:item="item"></slot>
            </template>
        </c-index>
    </div>
</div>
